"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertyListingsPropertyListingsGetRequest$ = exports.GetPropertyListingsPropertyListingsGetRequest$outboundSchema = exports.GetPropertyListingsPropertyListingsGetRequest$inboundSchema = exports.GetPropertyListingsPropertyListingsGetSecurity$ = exports.GetPropertyListingsPropertyListingsGetSecurity$outboundSchema = exports.GetPropertyListingsPropertyListingsGetSecurity$inboundSchema = void 0;
exports.getPropertyListingsPropertyListingsGetSecurityToJSON = getPropertyListingsPropertyListingsGetSecurityToJSON;
exports.getPropertyListingsPropertyListingsGetSecurityFromJSON = getPropertyListingsPropertyListingsGetSecurityFromJSON;
exports.getPropertyListingsPropertyListingsGetRequestToJSON = getPropertyListingsPropertyListingsGetRequestToJSON;
exports.getPropertyListingsPropertyListingsGetRequestFromJSON = getPropertyListingsPropertyListingsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetPropertyListingsPropertyListingsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPropertyListingsPropertyListingsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyListingsPropertyListingsGetSecurity$;
(function (GetPropertyListingsPropertyListingsGetSecurity$) {
    /** @deprecated use `GetPropertyListingsPropertyListingsGetSecurity$inboundSchema` instead. */
    GetPropertyListingsPropertyListingsGetSecurity$.inboundSchema = exports.GetPropertyListingsPropertyListingsGetSecurity$inboundSchema;
    /** @deprecated use `GetPropertyListingsPropertyListingsGetSecurity$outboundSchema` instead. */
    GetPropertyListingsPropertyListingsGetSecurity$.outboundSchema = exports.GetPropertyListingsPropertyListingsGetSecurity$outboundSchema;
})(GetPropertyListingsPropertyListingsGetSecurity$ || (exports.GetPropertyListingsPropertyListingsGetSecurity$ = GetPropertyListingsPropertyListingsGetSecurity$ = {}));
function getPropertyListingsPropertyListingsGetSecurityToJSON(getPropertyListingsPropertyListingsGetSecurity) {
    return JSON.stringify(exports.GetPropertyListingsPropertyListingsGetSecurity$outboundSchema.parse(getPropertyListingsPropertyListingsGetSecurity));
}
function getPropertyListingsPropertyListingsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyListingsPropertyListingsGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPropertyListingsPropertyListingsGetSecurity' from JSON`);
}
/** @internal */
exports.GetPropertyListingsPropertyListingsGetRequest$inboundSchema = z.object({
    listing_id: z.array(z.string()),
    point: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "listing_id": "listingId",
    });
});
/** @internal */
exports.GetPropertyListingsPropertyListingsGetRequest$outboundSchema = z.object({
    listingId: z.array(z.string()),
    point: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        listingId: "listing_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyListingsPropertyListingsGetRequest$;
(function (GetPropertyListingsPropertyListingsGetRequest$) {
    /** @deprecated use `GetPropertyListingsPropertyListingsGetRequest$inboundSchema` instead. */
    GetPropertyListingsPropertyListingsGetRequest$.inboundSchema = exports.GetPropertyListingsPropertyListingsGetRequest$inboundSchema;
    /** @deprecated use `GetPropertyListingsPropertyListingsGetRequest$outboundSchema` instead. */
    GetPropertyListingsPropertyListingsGetRequest$.outboundSchema = exports.GetPropertyListingsPropertyListingsGetRequest$outboundSchema;
})(GetPropertyListingsPropertyListingsGetRequest$ || (exports.GetPropertyListingsPropertyListingsGetRequest$ = GetPropertyListingsPropertyListingsGetRequest$ = {}));
function getPropertyListingsPropertyListingsGetRequestToJSON(getPropertyListingsPropertyListingsGetRequest) {
    return JSON.stringify(exports.GetPropertyListingsPropertyListingsGetRequest$outboundSchema.parse(getPropertyListingsPropertyListingsGetRequest));
}
function getPropertyListingsPropertyListingsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyListingsPropertyListingsGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPropertyListingsPropertyListingsGetRequest' from JSON`);
}
//# sourceMappingURL=getpropertylistingspropertylistingsget.js.map